<template>
  <div id="app">
    <AppLoader :active="!appReady" />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
<script setup>
  import { ref, onMounted } from 'vue';

  const heroImageByPath = {
    '/': '/cover.jpg',
    '/jobs': '/images/jobs.jpg',
    '/about': '/images/about/cover.jpg',
    '/contact': '/images/contact.jpg',
    '/recruitment': '/images/recruitment.jpg',
  };
  
  const appReady = ref(false);
  const route = useRoute();

  if (process.client) {
    onMounted(() => {
      // Only show the full splash once per tab. SPA route changes and
      // repeat visits within the session go straight to the page.
      if (sessionStorage.getItem('ey-app-ready')) {
        appReady.value = true;
        return;
      }

      const heroSrc = heroImageByPath[route.path];

      const heroReady = heroSrc
        ? new Promise((resolve) => {
            const img = new Image();
            img.onload = resolve;
            img.onerror = resolve;
            img.src = heroSrc;
            if (img.complete) resolve();
          })
        : Promise.resolve();

      const fontsReady = document.fonts ? document.fonts.ready.catch(() => {}) : Promise.resolve();

      const minimumDelay = new Promise((resolve) => setTimeout(resolve, 450));
      const hardCap = new Promise((resolve) => setTimeout(resolve, 2500));

      document.documentElement.classList.add('is-app-loading');

      Promise.race([Promise.all([heroReady, fontsReady, minimumDelay]), hardCap]).then(() => {
        appReady.value = true;
        document.documentElement.classList.remove('is-app-loading');
        sessionStorage.setItem('ey-app-ready', '1');
      });
    });
  }

  useHead({
    title: 'Home',
    titleTemplate: '%s - Early Years Recruitment',
    link: [
      { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
      { rel: 'preconnect', href: 'https://fonts.gstatic.com' },
      {
        rel: 'stylesheet',
        href: 'https://fonts.googleapis.com/css2?family=Work+Sans:wght@100;200;300;400;500;600;700;800;900&display=swap"',
      },
    ],
    meta: [
      {
        key: 'description',
        name: 'description',
        content:
          'Recruitment Specialists for Early Years Staff and Education Sectors. Whether you are seeking outstanding Teaching or Early Years Staff or searching for your next career move we can help you.',
      },
      {
        key: 'keywords',
        name: 'keywords',
        content:
          'early years, recruitment, day care, education, teacher, teaching, children, kids, schools, nurseries, care',
      },
      {
      key: 'og:title',
      property: 'og:title',
      content: 'Early Years Recruitment',
    },
    {
      key: 'og:description',
      property: 'og:description',
      content:
        'Recruitment Specialists for Early Years Staff and Education Sectors. Whether you are seeking outstanding Teaching or Early Years Staff or searching for your next career move we can help you.',
    },
    {
      key: 'og:image',
      property: 'og:image',
      content: 'https://early-years.com/_nuxt/logo-light.88ce728c.png',
    },
    {
      key: 'og:image:secure_url',
      property: 'og:image:secure_url',
      content: 'https://early-years.com/_nuxt/logo-light.88ce728c.png',
    },
    {
      key: 'og:image:alt',
      property: 'og:image:alt',
      content: 'Early Years Recruitment',
    },
    ]
  })
</script>
